module.exports = __webpack_public_path__ + "588b7de1aac161679638ced9337bbe6f.ttf";